import { useState, useEffect } from 'react';
import { translate } from 'react-i18next';
import moment from 'moment';

// Components
import CampusesSelect from '../../../../FiltersSection/CampusesSelect';
import PractitionersList from '../../../../FiltersSection/PractitionersList';
import TimePicker from 'components/TimePicker';
import { InputTextArea } from 'components/Fields';

// Styles
import * as modalStyles from 'components/CustomModal/styles';

function round(date, duration = moment.duration(5, 'minutes'), method = 'ceil') {
  return moment(Math[method](+date / +duration) * +duration);
}

function getPrefCampus(list, campusId) {
  if (Array.isArray(list) && list.length && campusId) {
    return list.find(campus => campus && String(campus.id) === String(campusId));
  }
}

function L_CreateNewAppointment({
  i18n,
  appointmentData,
  campusesList,
  disableSection,
  preferCampusId,
  onChangeNewAppointment,
  practitionersList
}) {
  const [appointmentSettings, setAppointmentSettings] = useState({
    noteMessage: null,
    practitionerId: appointmentData && appointmentData.practitionerId,
    campus:
      getPrefCampus(campusesList, preferCampusId) ||
      (Array.isArray(campusesList) && campusesList[0]),
    time: appointmentData && round(moment.utc(appointmentData.arrivedDateTime).local())
  });

  useEffect(
    () => {
      if (onChangeNewAppointment) {
        onChangeNewAppointment(appointmentSettings);
      }
    },
    [appointmentSettings]
  );

  const setState = obj => {
    setAppointmentSettings(state => ({ ...state, ...obj }));
  };

  const { practitionerId, campus, time } = appointmentSettings;

  return (
    <section>
      <h3>{i18n.t('create_new_appointment')}</h3>
      <modalStyles.ModalText className="bn-m-small">
        {i18n.t('select_practitioner')}
      </modalStyles.ModalText>
      <PractitionersList
        disabled={disableSection}
        practitioners={practitionersList}
        practitionerId={practitionerId}
        onChangePractitioner={doctor => {
          setState({ practitionerId: doctor.id });
        }}
      />
      <modalStyles.ModalText className="bn-m-small">
        {i18n.t('select_location')}
      </modalStyles.ModalText>
      <CampusesSelect
        campuses={campusesList}
        disabled={disableSection}
        excludeAllLocales={true}
        selectedCampusId={campus && campus.id}
        onChangeCampus={campus => {
          setState({ campus: campus });
        }}
      />
      <modalStyles.ModalText className="bn-m-small">
        {i18n.t('select_appointment_time')}
      </modalStyles.ModalText>

      <TimePicker
        defaultValue={time}
        disabled={disableSection}
        showSecond={false}
        minuteStep={5}
        hideDisabledOptions
        clearIcon={false}
        onChange={time => {
          setState({ time: time });
        }}
      />

      <InputTextArea
        disabled={disableSection}
        label={i18n.t('note_text_area_label')}
        placeholder={i18n.t('leave_note_here')}
        optional
        input={{
          onChange: e => {
            setState({ noteMessage: e.target.value });
          }
        }}
      />
    </section>
  );
}

export default translate()(L_CreateNewAppointment);
